// extracted by mini-css-extract-plugin
export default {"square-frame":"SquareFrame__square-frame___G3dJg","small":"SquareFrame__small___-6BFQ","medium":"SquareFrame__medium___NUqWD","large":"SquareFrame__large___kC1P0"};